import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { EvaluatorCard } from '../../common/EvaluatorCard/EvaluatorCard'

import type { InterviewEvaluator } from '../../types'

import styles from './EvaluatorCards.module.scss'

type EvaluatorCardsProps = {
  className?: string
  evaluators?: InterviewEvaluator[]
}

export const EvaluatorCards = ({
  className = undefined,
  evaluators = [],
}: EvaluatorCardsProps) => {
  return (
    <Box
      className={cx(styles.cards, { [className ?? '']: Boolean(className) })}
      direction="column"
      tagName="article"
    >
      <Box align="center" className={styles.heading} justify="space-between">
        <h3 className={styles.title}>{t`Evaluators`}</h3>
      </Box>
      {evaluators.length > 0 ? (
        <List className={styles.list} direction="column">
          {evaluators.map(({ email, id, name, status }) => (
            <List.Item className={styles.item} key={id}>
              <EvaluatorCard {...{ email, name, status }} />
            </List.Item>
          ))}
        </List>
      ) : (
        <p className={styles.placeholder}>{t`No evaluators yet`}</p>
      )}
    </Box>
  )
}
